<template>
  <div class="view box grow" style="overflow-y: auto">
    <page-headers
        :header="header"
        :breadcrumbs="breadcrumbs"
        :is-border="true"
        :documentation="userGuide"
        class="box"
    />
    <el-tabs v-model="activeView" @tab-click="changeView">
      <el-tab-pane label="Detections" name="detections"></el-tab-pane>
      <el-tab-pane label="Rules" name="rules"></el-tab-pane>
    </el-tabs>

    <router-view class="full-height"/>
  </div>
</template>

<script>
import PageHeaders from '@/components/layout/PageHeaders.vue'

export default {
  name: 'AnomaliesView',
  data() {
    return {
      header: 'Detections',
      breadcrumbs: [{title: 'Threats'}, {title: 'Anomalies'}, {title: 'Detections'}],
      activeView: 'detections',
      routePath: '/anomalies/detections',
      userGuide: 'page-anomalies'
    }
  },
  beforeMount() {
    this.userGuide = 'page-anomalies'

    // If window refreshed, stay on previous rules page
    if (performance.navigation.type === 1) {
      this.$router.push({name: this.$route.name, params: this.$route.params, query: this.$route.query})
      this.activeView = this.$route.path.split('/').reverse()[0]
    } else {
      // set default path for attack progression rules
      this.$router.push({name: 'anomalies-detections', params: this.$route.params, query: this.$route.query})
    }

    if (this.activeView === 'rules') {
      this.header = 'Rules'
      this.breadcrumbs = [{title: 'Threats'}, {title: 'Anomalies'}, {title: 'Rules'}]
      this.routePath = '/anomalies/rules'
      this.userGuide = 'page-anomalies-rules'
    }
  },
  methods: {
    changeView(tab, event) {
      this.userGuide = 'page-anomalies'
      if (tab.name === 'rules') {
        this.header = 'Rules'
        this.breadcrumbs = [{title: 'Threats'}, {title: 'Anomalies'}, {title: 'Rules'}]
        this.routePath = '/anomalies/rules'
        this.userGuide = 'page-anomalies-rules'
      } else {
        this.header = 'Detections'
        this.breadcrumbs = [{title: 'Threats'}, {title: 'Anomalies'}, {title: 'Detections'}]
        this.routePath = '/anomalies/detections'
      }
      this.$router.push(this.routePath)
    }
  },
  components: {
    PageHeaders
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }

    span {
      color: white;
      margin-bottom: 6px;
    }

    a {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/anomalies/AnomaliesView.vue